import { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaBackward } from "react-icons/fa";
import Logo from "../assest/l.png";
import { forgotPassword } from "../utils/api";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      const response = await forgotPassword(email);
      if (response.success) {
        setSuccess(true);
      } else {
        setError(response.message || "Failed to send reset email");
      }
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full h-[100dvh] lg:h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
      {/* Logo */}
      <div className="absolute top-10 left-10">
        <Link to="/">
          <img src={Logo} alt="Tactos Logo" className="w-28" />
        </Link>
      </div>

      {/* Auth Card */}
      <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
        <div className="md:w-1/2 w-full px-8 py-6 h-full flex flex-col justify-center items-center">
          <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
            Forgot Password
          </h2>

          {success ? (
            <div className="text-center mt-6">
              <h3 className="text-2xl font-semibold text-green-600 mb-4">
                Email Sent!
              </h3>
              <p className="text-gray-600 mb-4">
                We've sent an email to {email} with instructions to reset your password.
              </p>
              <p className="text-gray-600">
                Didn't receive the email? Check your spam folder or{" "}
                <button 
                  onClick={handleSubmit}
                  className="text-indigo-600 hover:underline"
                >
                  try again
                </button>.
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="space-y-5 text-sm w-full lg:w-1/2 mx-auto"
            >
              {error && (
                <motion.div
                  initial={{ y: -10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.2 }}
                  className="bg-red-100 text-red-700 p-3 rounded text-sm"
                >
                  {error}
                </motion.div>
              )}

              <div className="flex flex-col">
                <label
                  htmlFor="email"
                  className="text-gray-700 font-medium mb-1"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                  placeholder="Your registered email"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm ${
                  loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
              >
                {loading ? "Sending..." : "Reset Password"}
              </button>

              <div className="flex justify-center mb-6 text-gray-600 text-sm">
                Remember your password?{" "}
                <Link
                  to="/startup-login"
                  className="text-indigo-600 hover:underline ml-1"
                >
                  Login
                </Link>
              </div>
            </form>
          )}
        </div>

        <div className="md:w-1/2 hidden lg:block relative overflow-hidden">
          <img
            src="/login_img.jpg"
            alt="Startup Illustration"
            className="w-full lg:h-full object-cover"
          />
          <Link
            to="/"
            className="absolute top-4 right-4 flex items-center gap-2 text-black font-bold"
          >
            <FaBackward /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;